import type { User } from "../model";
import API, { responseOf } from "./base";

export const register = async (): Promise<void> => {
  await API.post("/users/register");
};

export const get = (userId: string): Promise<User> =>
  responseOf(API.get(`/users/${userId}`));

export const update = (user: User): Promise<User> =>
  responseOf(API.put(`/users/${user.id}`, user));

export const byRoleId = (roleId: string, filter?: string): Promise<User[]> =>
  responseOf(
    API.get(`/users/byRoleId/${roleId}`, {
      params: { filter },
    }),
  );

export const leaveOrganization = async (
  userId: string,
  orgId: string,
): Promise<void> => {
  await API.post(`/users/${userId}/leaveOrganization/${orgId}`);
};
